var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subscriptions-list"},_vm._l((_vm.subscriptions),function(item){return _c('subscription-item',{key:item.id,attrs:{"subscription":item,"serviceTypes":_vm.serviceTypes}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }